<div class="d-flex justify-content-between">
  <div>
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div class="d-flex gap-3" *ngIf="selectedTabIndex != 4">
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="validateOrg(organization, organizationImage)"
      (keydown.enter)="validateOrg(organization, organizationImage)">
      <i class="fas fa-user-edit" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="report('Excel')"
      (keydown.enter)="report('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="report('Pdf')"
      (keydown.enter)="report('pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.isAuditTrailUser"
      (click)="openAuditTrail()" (keydown.enter)="openAuditTrail()">
      <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Audit Trail</span>
    </div>
  </div>
</div>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="tab">
  <mat-tab-group selectedIndex="0" mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4"
    (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex" animationDuration="0ms">

    <mat-tab label="Organization">
      <ng-template mat-tab-label>
        <span>Organization</span>
      </ng-template>
      <br>
      <div class="menu-container">
        <div class="d-flex menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="gridName">Details</span>
          </div>
          <div class="col-sm-6 action-buttons-container">
            <div class="reloadIconContiner" (click)="refreshForm()" (keydown.enter)="refreshForm()" matTooltip="Refresh"
              style="margin-right: 10px;">
              <i class="fas fa-redo-alt"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div><label for="email">Organization Short Name</label></div>
          <input class="input-filed-continers" name="orgShortName" type="text" [(ngModel)]="organization.orgShortName">
        </div>
        <div class="col-md-9">
          <div><label for="email">Organization Full Name</label></div>
          <input class="input-filed-continers" name="orgLongName" type="text" [(ngModel)]="organization.orgLongName">
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div><label for="email">Application Display Name</label></div>
          <input class="input-filed-continers" name="applicationName" type="text"
            [(ngModel)]="organization.applicationName">
        </div>
        <div class="col-md-3">
          <div><label for="email">Application URL</label></div>
          <input class="input-filed-continers" name="applicationUrl" type="text"
            [(ngModel)]="organization.applicationUrl" disabled>
        </div>
        <div class="col-md-3">
          <div><label for="email">Current Version</label></div>
          <input class="input-filed-continers" name="currentVersion" type="text"
            [(ngModel)]="organization.currentVersion" disabled>
        </div>
        <div class="col-md-3">
          <div><label for="email">Version Upgraded On</label></div>
          <input class="form-control data-picker-continer" name="versionUpgradedOn" bsDatepicker
            [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="organization.versionUpgradedOn" [disabled]="true">
        </div>
        <div class="col-md-3">
          <div><label for="email">User Session Timeout <span class="ancillary-label">(In Mins)</span></label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="organization.userSessionTimeoutInMins"
            (closed)="sessionSearchText=''" (click)="focusSearch('focus-session-time-out')"
            (keydown.enter)="focusSearch('focus-session-time-out')">
            <input type="search" id="focus-session-time-out" class="dropdownsearchstyle" [(ngModel)]="sessionSearchText"
              matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of session| assessmentSearch :sessionSearchText" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div><label for="email">Minimum Username Length</label></div>
          <input class="input-filed-continers" name="minimumUsernameLength" type="number"
            (keydown)="validateNumberFields($event)" [(ngModel)]="organization.minimumUsernameLength">
        </div>
        <div class="col-md-3">
          <div><label for="email">Minimum Password Length</label></div>
          <input id="minimumPasswordLength" class="input-filed-continers" name="c" type="number" min="8"
            (keydown)="validateNumberFields($event)" [(ngModel)]="organization.minimumPasswordLength">
          <span id="minimumpassword-invalid-msg">The minimum required password length is 8 characters</span>
        </div>
        <div class="col-md-3">
          <div><label for="email">User Password Expiry <span class="ancillary-label">(In Days)</span></label>
          </div>
          <input class="input-filed-continers" name="userPwdExpiry" type="number"
            (keydown)="validateNumberFields($event)" [(ngModel)]="organization.userPwdExpiry">
        </div>
        <div class="col-md-3">
          <div><label for="email">Reuse Password Cycle <span class="ancillary-label">(In Days)</span></label>
          </div>
          <input class="input-filed-continers" name="reusePwdCycle" type="number"
            (keydown)="validateNumberFields($event)" [(ngModel)]="organization.reusePwdCycle">
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div><label for="email">Allowed Failed Login Attempts</label></div>
          <input class="input-filed-continers" name="loginAttempts" type="number"
            (keydown)="validateNumberFields($event)" [(ngModel)]="organization.loginAttempts">
        </div>
        <div class="col-md-6">
          <div><label for="email">Email Domain</label></div>
          <input class="input-filed-continers" name="emailDomains" type="text" [(ngModel)]="organization.emailDomains">
        </div>
        <div class="col-md-3">
          <div><label for="email">Allow Multiple Users to Use Same Email?</label></div>
          <mat-slide-toggle color="primary" name="sameEmailToMultipleUsers"
            [(ngModel)]="organization.sameEmailToMultipleUsers">
            <ng-container *ngIf="organization.sameEmailToMultipleUsers; else noActive">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noActive>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div><label for="email">Reports Timezone</label></div>
            <mat-select matInput placeholder="Select"
              [ngClass]="{'odd-item-mat-select': oddTimeZone == selectedTimeZone}" [(ngModel)]="selectedTimeZone"
              (closed)="reportsTimeZoneSearchText=''" (click)="focusSearch('focusReportTimeZone')"
              (keydown.enter)="focusSearch('focusReportTimeZone')">
              <input type="search" id="focusReportTimeZone" class="dropdownsearchstyle"
                [(ngModel)]="reportsTimeZoneSearchText" matInput placeholder="Search">
              <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of timeZoneDropdown| assessmentSearch :reportsTimeZoneSearchText"
                [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-3">
            <div><label for="email">Is Active?</label></div>
            <mat-slide-toggle color="primary" name="isActive" [(ngModel)]="organization.isActive" disabled>
              <ng-container *ngIf="organization.isActive; else noActive">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noActive>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-3">
            <div><label for="email">Stop Emails?</label></div>
            <mat-slide-toggle color="primary" name="stopEmails" [(ngModel)]="organization.stopEmails">
              <ng-container *ngIf="organization.stopEmails; else noStopEmails">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noStopEmails>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-3">
            <div><label for="email">User Name Format At Application</label></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedNameFormatForApp"
              [ngClass]="{'odd-item-mat-select': oddNameFormatForApp== selectedNameFormatForApp}"
              (closed)="userNameApplicationSearchText=''" (click)="focusSearch('focusUserNameApplication')"
              (keydown.enter)="focusSearch('focusUserNameApplication')">
              <input type="search" id="focusUserNameApplication" class="dropdownsearchstyle"
                [(ngModel)]="userNameApplicationSearchText" matInput placeholder="Search">
              <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of nameFormatDropdown| assessmentSearch :userNameApplicationSearchText"
                [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div><label for="email">User Name Format At Reports</label></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedNameFormatForRep"
              [ngClass]="{'odd-item-mat-select': oddNameFormatForRep== selectedNameFormatForRep}"
              (closed)="userNameFormatForRepSearchText=''" (click)="focusSearch('focusUserNameFormatForRep')"
              (keydown.enter)="focusSearch('focusUserNameFormatForRep')">
              <input type="search" id="focusUserNameFormatForRep" class="dropdownsearchstyle"
                [(ngModel)]="userNameFormatForRepSearchText" matInput placeholder="Search">
              <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of nameFormatDropdown| assessmentSearch :userNameFormatForRepSearchText"
                [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-3">
            <div><label for="email">Date Format</label></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedDateFormat"
              [ngClass]="{'odd-item-mat-select': oddDateFormat== selectedDateFormat}" (closed)="dateFormatSearchText=''"
              (click)="focusSearch('focusDateFormat')" (keydown.enter)="focusSearch('focusDateFormat')">
              <input type="search" id="focusDateFormat" class="dropdownsearchstyle" [(ngModel)]="dateFormatSearchText"
                matInput placeholder="Search">
              <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of dateFormatDropdown| assessmentSearch :dateFormatSearchText"
                [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-6">
            <div><label for="email">Allowed File Extns</label></div>
            <input class="input-filed-continers" name="emailDomains" type="text"
              [(ngModel)]="organization.allowedFileExtns" disabled>
          </div>
          <div class="col-md-3">
            <div><label for="email">Allowed File Size(In MB)
                <span class="ancillary-label" *ngIf="organization.allowedFileSizeInMb">
                  {{ formatBytes(organization.allowedFileSizeInMb) }} bytes
                </span>
              </label></div>
            <input class="input-filed-continers" name="emailDomains" type="text"
              [(ngModel)]="organization.allowedFileSizeInMb" min="5" max="5120" [disabled]="true">
          </div>

          <div class="col-md-3">
            <div>
              <label for="email">Max Parallel Documents Upload Count </label>
            </div>
            <input class="input-filed-continers" name="doc-count" type="number" (keydown)="validateNumberFields($event)"
              [(ngModel)]="organization.maxParallelUploadDocuments" min="2" max="10" (input)="onDocCountInput($event)"
              [disabled]="false">
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div><label for="email">Override User Session</label></div>
            <mat-slide-toggle color="primary" name="stopEmails" [(ngModel)]="organization.allowUserInParallelSession"
              disabled>
              <ng-container *ngIf="organization.allowUserInParallelSession; else noParallelSession">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noParallelSession>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-3">
            <div><label for="email">Location</label></div>
            <mat-select matInput multiple placeholder="Select" #organizationCountry [(ngModel)]="selectedOrgCountries"
              (closed)="orgCountriesSearchText=''" (click)="focusSearch('focusOrgCountries')"
              (keydown.enter)="focusSearch('focusOrgCountries')">
              <input type="search" id="focusOrgCountries" class="dropdownsearchstyle"
                [(ngModel)]="orgCountriesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isAllOrgCountriesSelected"
                  (change)="toggleAllSelection('organizationCountry')">Select All</mat-checkbox>
              </div>
              <mat-option *ngFor="let item1 of orgCountriesDropdown | multiAssessmentSearchPipe :orgCountriesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onOrgCountriesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-3">
            <div><label for="email">Hide User Name?</label></div>
            <mat-slide-toggle color="primary" name="stopEmails" [(ngModel)]="organization.hideUserName">
              <ng-container *ngIf="organization.hideUserName; else hideUserName">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #hideUserName>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-3">
            <div><label for="email">Allow Mobile/Tablet Access?</label></div>
            <mat-slide-toggle color="primary" name="stopEmails" [(ngModel)]="organization.isAllowMobileAccess">
              <ng-container *ngIf="organization.isAllowMobileAccess; else isAllowMobileAccess">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #isAllowMobileAccess>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>

          <div class="col-md-3">
            <div><label for="email">Enable Password Authentication for Document Downloads?</label></div>
            <mat-slide-toggle color="primary" name="isDocPasswordReqd"
              [(ngModel)]="organization.isDocumentPasswordReqd">
              <ng-container *ngIf="organization.isDocumentPasswordReqd; else isDocumentPasswordReqd">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #isDocumentPasswordReqd>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Privileges">
      <ng-template mat-tab-label>
        <span>License and Privileges</span>
      </ng-template> <br>

      <div class="menu-container">
        <div class="row menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="gridName">License Terms</span>
          </div>
        </div>
      </div> <br>

      <div class="row">
        <div class="col-md-3">
          <div><label for="email">Started On</label></div>
          <input class="form-control data-picker-continer" name="licenseStartedOn" bsDatepicker
            [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="organization.licenseStartedOn" [disabled]="true">
        </div>
        <div class="col-md-3">
          <div><label for="email">Renewed On</label></div>
          <input class="form-control data-picker-continer" name="licenseRenewedOn" bsDatepicker
            [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="organization.licenseRenewedOn" [disabled]="true">
        </div>

        <div class="col-md-3">
          <div *ngIf="licenseExpiryDateStatus == 'Past'"><label for="email">Expired On</label></div>
          <div *ngIf="licenseExpiryDateStatus == 'Present'"><label for="email">Expiring Today</label></div>
          <div *ngIf="licenseExpiryDateStatus == 'Future'"><label for="email">Expiry Date
              <span class="ancillary-label">(Expires in {{remainingDays}}
                <span *ngIf="remainingDays == 1">Day</span>
                <span *ngIf="remainingDays != 1">Days</span>)
              </span></label>
          </div>
          <div *ngIf="licenseExpiryDateStatus == null"><label for="email">Expiry Date</label></div>
          <input id="licenseExpiryDate" class="form-control data-picker-continer" name="licenseExpiryDate" bsDatepicker
            [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="organization.licenseExpiryDate" disabled>
          <span *ngIf="organization.licenseExpiryDate != null">Your license
            <span *ngIf="licenseExpiryDateStatus == 'Past'">has expired !</span>
            <span *ngIf="licenseExpiryDateStatus == 'Present'">is expiring today !</span>
          </span>
        </div>
        <div class="col-md-3">
          <div><label for="email">Warning Period <span class="ancillary-label">(In Days)</span></label></div>
          <input class="input-filed-continers" name="licenseWarningPeriodInDays" type="text"
            [(ngModel)]="organization.licenseWarningPeriodInDays" disabled>
        </div>
      </div> <br>

      <div class="menu-container">
        <div class="row menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="gridName">License Modules</span>
          </div>
        </div>
      </div> <br>

      <div class="row">
        <div class="col-md-2">
          <div><label for="email">Quality?</label></div>
          <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="isQuality" disabled>
            <ng-container *ngIf="isQuality; else noQuality">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noQuality>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
        <div class="col-md-2">
          <div><label for="email">Trainings?</label></div>
          <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.trn" disabled>
            <ng-container *ngIf="organizationPrivilege.trn; else noTrn">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noTrn>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
        <div class="col-md-2">
          <div><label for="email">Documents?</label></div>
          <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.docs" disabled>
            <ng-container *ngIf="organizationPrivilege.docs; else noDocs">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noDocs>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
        <div class="col-md-2">
          <div><label for="email">Forms and Logs?</label></div>
          <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.formsAndLogs" disabled>
            <ng-container *ngIf="organizationPrivilege.formsAndLogs; else noFormsAndLogs">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noFormsAndLogs>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
        <div class="col-md-2">
          <div><label for="email">Business Process?</label></div>
          <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.bp" disabled>
            <ng-container *ngIf="organizationPrivilege.bp; else noBp">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noBp>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div> <br>

      <div class="menu-container">
        <div class="row menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="gridName">Modules / User Limits</span>
          </div>
        </div>
      </div> <br>

      <div class="col-md-12 d-flex" style="margin: 15px;" *ngIf="isQuality">
        <div class="col-md-5 d-flex">
          <div class="col-md-4">
            <div><label for="email">Change Request?</label></div>
            <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.cr" disabled>
              <ng-container *ngIf="organizationPrivilege.cr; else noCr">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noCr>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-4">
            <div><label for="email">CAPA?</label></div>
            <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.capa" disabled>
              <ng-container *ngIf="organizationPrivilege.capa; else noCapa">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noCapa>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-4">
            <div><label for="email">Deviation?</label></div>
            <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.dv" disabled>
              <ng-container *ngIf="organizationPrivilege.dv; else noDv">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noDv>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
        </div>
        <div class="col-md-5 d-flex">
          <div class="col-md-4">
            <div><label for="email">Audit?</label></div>
            <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.au" disabled>
              <ng-container *ngIf="organizationPrivilege.au; else noAu">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noAu>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-4">
            <div><label for="email">Incident?</label></div>
            <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.in" disabled>
              <ng-container *ngIf="organizationPrivilege.in; else noIn">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noIn>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-4">
            <div><label for="email">Quality Issue?</label></div>
            <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.qi" disabled>
              <ng-container *ngIf="organizationPrivilege.qi; else noQi">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noQi>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
        </div>
        <div class="col-md-2 d-flex">
          <div class="col-md-6" *ngIf="isQuality">
            <div><label for="email">Customer Complaint?</label></div>
            <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.cc" disabled>
              <ng-container *ngIf="organizationPrivilege.cc; else noCc">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noCc>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-6" *ngIf="isQuality">
            <div><label for="email">Out Of Specification?</label></div>
            <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organizationPrivilege.oos" disabled>
              <ng-container *ngIf="organizationPrivilege.oos; else nooos">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #nooos>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
        </div>
      </div> <br *ngIf="isQuality">

      <div class="col-md-12 d-flex flex-wrap" style="margin: 15px; gap: 10px;">
        <div class="flex-item" *ngIf="isQuality">
          <div><label for="qualityTaskCount">Quality Task Count</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="organizationPrivilege.qualityTaskCount"
            disabled>
        </div>
        <div class="flex-item" *ngIf="organizationPrivilege.qi">
          <div><label for="qualityUserCount">Quality User Count</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="organizationPrivilege.qualityUserCount"
            disabled>
        </div>
        <div class="flex-item" *ngIf="organizationPrivilege.trn">
          <div><label for="trainingUserCount">Training User Count</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="organizationPrivilege.trnUserCount" disabled>
        </div>
        <div class="flex-item" *ngIf="organizationPrivilege.docs">
          <div><label for="documentUserCount">Document User Count</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="organizationPrivilege.docsUserCount" disabled>
        </div>
        <div class="flex-item">
          <div><label for="concurrentUserCount">Concurrent User Count</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="organizationPrivilege.concurrentUserCount"
            disabled>
        </div>
        <div class="flex-item" *ngIf="organizationPrivilege.formsAndLogs">
          <div><label for="formsAndLogsCount">Forms and Logs Count</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="organizationPrivilege.formsAndLogsCount"
            disabled>
        </div>
        <div class="flex-item" *ngIf="organizationPrivilege.bp">
          <div><label for="businessProcessCount">Business Process Count</label></div>
          <input class="input-filed-continers" type="text" [(ngModel)]="organizationPrivilege.bpSetupCount" disabled>
        </div>
      </div> <br>

      <div class="menu-container">
        <div class="row menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="gridName">AD Settings</span>
          </div>
        </div>
      </div> <br>

      <div class="row" [ngStyle]="{'margin-bottom':'170px'}">
        <div class="col-md-2">
          <div><label for="email">AD Enabled?</label></div>
          <mat-slide-toggle color="primary" name="adEnabled" [(ngModel)]="organization.adEnabled" [disabled]="true">
            <ng-container *ngIf="organization.adEnabled; else noAdEnabled">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noAdEnabled>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
        <div class="col-md-4" *ngIf="organization.adEnabled">
          <div><label for="email">AD Type</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedADType" (closed)="adSearchText=''"
            (click)="focusSearch('ad-type')" (keydown.enter)="focusSearch('ad-type')">
            <input type="search" id="ad-type" class="dropdownsearchstyle" [(ngModel)]="adSearchText" matInput
              placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of adListDropdown| assessmentSearch :adSearchText" [value]="item.valueExp"> {{
              item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Images">
      <ng-template mat-tab-label>
        <span>Images</span>
      </ng-template> <br>

      <div class="menu-container">
        <div class="row menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="gridName">Images and User Guide</span>
          </div>
        </div>
      </div> <br>

      <div class="row">
        <!--  Logo Image -->
        <div class="col-md-4 text-center">
          <!-- Title -->
          <label class="img-title" for="title">Logo</label>
          <!-- Image -->
          <div class="org-image-wrapper">
            <img class="img-box" *ngIf="!logoImg && organizationImage?.logoImage"
              src="data:image/*;base64,{{organizationImage.logoImage}}" alt="Logo">
            <img class="img-box" *ngIf="logoImg" [src]="logoImgPreview" alt="Logo">
            <img class="img-box" *ngIf="!logoImg && !organizationImage?.logoImage" src="../../assets/img/no-image.png"
              alt="No Logo">
          </div>
          <!-- Buttons -->
          <div class="img-action-buttons">
            <button *ngIf="!organizationImage?.logoImage && !logoImg" mat-mini-fab class="img-btn" matTooltip="Upload"
              (click)="triggerFileSelection('logo-upload')">
              <i class="fa fa-upload"></i>
            </button>
            <button *ngIf="organizationImage?.logoImage || logoImg" mat-mini-fab class="img-btn" matTooltip="Replace"
              (click)="triggerFileSelection('logo-replace')">
              <i class="fa fa-exchange"></i>
            </button>
            <button *ngIf="organizationImage?.logoImage || logoImg" mat-mini-fab class="img-btn" matTooltip="Remove"
              (click)="triggerFileSelection('logo-remove')">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <!-- Login Image -->
        <div class="col-md-4 text-center">
          <!-- Title -->
          <label class="img-title" for="title">Login</label>
          <!-- Image -->
          <div class="org-image-wrapper">
            <img class="img-box" *ngIf="!loginImg && organizationImage?.loginImage"
              src="data:image/*;base64,{{organizationImage.loginImage}}" alt="Logo">
            <img class="img-box" *ngIf="loginImg" [src]="loginImgPreview" alt="Logo">
            <img class="img-box" *ngIf="!loginImg && !organizationImage?.loginImage" src="../../assets/img/no-image.png"
              alt="No Logo">
          </div>
          <!-- Buttons -->
          <div class="img-action-buttons">
            <button *ngIf="!organizationImage?.loginImage && !loginImg" mat-mini-fab class="img-btn" matTooltip="Upload"
              (click)="triggerFileSelection('login-upload')">
              <i class="fa fa-upload"></i>
            </button>
            <button *ngIf="organizationImage?.loginImage || loginImg" mat-mini-fab class="img-btn" matTooltip="Replace"
              (click)="triggerFileSelection('login-replace')">
              <i class="fa fa-exchange"></i>
            </button>
            <button *ngIf="organizationImage?.loginImage || loginImg" mat-mini-fab class="img-btn" matTooltip="Remove"
              (click)="triggerFileSelection('login-remove')">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <!-- Report Image -->
        <div class="col-md-4 text-center">
          <!-- Title -->
          <label class="img-title" for="title">Report</label>
          <!-- Image -->
          <div class="org-image-wrapper">
            <img class="img-box" *ngIf="!reportImg && organizationImage?.reportImage"
              src="data:image/*;base64,{{organizationImage.reportImage}}" alt="Logo">
            <img class="img-box" *ngIf="reportImg" [src]="reportImgPreview" alt="Logo">
            <img class="img-box" *ngIf="!reportImg && !organizationImage?.reportImage"
              src="../../assets/img/no-image.png" alt="No Logo">
          </div>
          <!-- Buttons -->
          <div class="img-action-buttons">
            <button *ngIf="!organizationImage?.reportImage && !reportImg" mat-mini-fab class="img-btn"
              matTooltip="Upload" (click)="triggerFileSelection('report-upload')">
              <i class="fa fa-upload"></i>
            </button>
            <button *ngIf="organizationImage?.reportImage || reportImg" mat-mini-fab class="img-btn"
              matTooltip="Replace" (click)="triggerFileSelection('report-replace')">
              <i class="fa fa-exchange"></i>
            </button>
            <button *ngIf="organizationImage?.reportImage || reportImg" mat-mini-fab class="img-btn" matTooltip="Remove"
              (click)="triggerFileSelection('report-remove')">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <br><br>

      <!-- Slide Toggles Row -->
      <div class="row align-items-center">
        <div class="col-md-4 text-center">
          <div class="toggle-card">
            <div><label for="email">Is Logo Image Square?</label></div>
            <mat-slide-toggle color="primary" name="logoEnabled" [(ngModel)]="organizationImage.isLogoImageSquare">
              <ng-container *ngIf="organizationImage.isLogoImageSquare; else noLogoImageSquare">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noLogoImageSquare>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
        </div>

        <div class="col-md-4 text-center">
          <div class="toggle-card">
            <div><label for="email">Is Login Image Square?</label></div>
            <mat-slide-toggle color="primary" name="loginEnabled" [(ngModel)]="organizationImage.isLoginImageSquare">
              <ng-container *ngIf="organizationImage.isLoginImageSquare; else noLoginImageSquare">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noLoginImageSquare>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
        </div>

        <div class="col-md-4 text-center">
          <div class="toggle-card">
            <div><label for="email">Is Report Image Square?</label></div>
            <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="organizationImage.isReportImageSquare">
              <ng-container *ngIf="organizationImage.isReportImageSquare; else noReportImageSquare">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noReportImageSquare>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
        </div>
      </div>

      <br><br>

      <!-- Editors Row (Ready for Editor 1 & Editor 2 side by side) -->
      <div class="row">
        <div class="col-md-6">
          <div class="editor-wrapper">
            <label for="email" class="d-block font-weight-bold mb-2">Custom User Guide</label>
            <div class="org-image-wrapper">
              <web-viewer [data]="viewerData" *ngIf="!clientUserGuide && organizationImage?.clientUserGuide"
                (oneQmsListener)="onUserActivity()"></web-viewer>
              <web-viewer [data]="clientUserGuideViewer" *ngIf="clientUserGuide"
                (oneQmsListener)="onUserActivity()"></web-viewer>
              <img class="img-box" *ngIf="!clientUserGuide && !organizationImage?.clientUserGuide"
                src="../../assets/img/no-image.png" alt="No Logo">
            </div>
            <!-- Buttons -->
            <div class="img-action-buttons">
              <button *ngIf="!organizationImage?.clientUserGuide && !clientUserGuide" mat-mini-fab class="img-btn"
                matTooltip="Upload" (click)="triggerFileSelection('user-guide-upload')">
                <i class="fa fa-upload"></i>
              </button>
              <button *ngIf="organizationImage?.clientUserGuide || clientUserGuide" mat-mini-fab class="img-btn"
                matTooltip="Replace" (click)="triggerFileSelection('user-guide-replace')">
                <i class="fa fa-exchange"></i>
              </button>
              <button *ngIf="organizationImage?.clientUserGuide || clientUserGuide" mat-mini-fab class="img-btn"
                matTooltip="Remove" (click)="triggerFileSelection('user-guide-remove')">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Editor 1 -->
        <div class="col-md-6">
          <div class="editor-wrapper">
            <label for="email" class="d-block font-weight-bold mb-2">Login Page Content</label>
            <div class="d-flex align-items-center justify-content-center gap-2">
              <div class="hideToolbar flex-grow-1">
                <st-editor [(ngModel)]="organizationImage.loginpageContent" [config]="buttonsExcludedConfig"
                  [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
              </div>
              <div class="angular-editor-edit cursor-pointer" (click)="openEditor('Login Page Content')"
                (keydown.enter)="openEditor('Login Page Content')">
                <i class="far fa-edit"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br><br>

      <div class="menu-container">
        <div class="row menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="gridName">Additional Images</span>
          </div>
        </div>
      </div> <br>

      <div class="row">
        <div class="table-container">
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center px-3">
              <div class="dropdown">
              </div>
            </div>
            <div class="d-flex gap-3">
              <div class="header-container">
                <div class="">
                  <div class="search-container">
                    <span class="fa fa-search form-control-feedback"></span>
                    <input type="text" class="form-control search_input" style="font-size: 12px"
                      placeholder="Search here..." [(ngModel)]="searchValue" />
                  </div>
                </div>
              </div>
              <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openAddReportImagePopup()" (keydown.enter)="openAddReportImagePopup()">
                <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                <span class="reload_text text-white">Add New</span>
              </div>
              <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openImageReport('Excel')" (keydown.enter)="openImageReport('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
              </div>
              <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openImageReport('Pdf')" (keydown.enter)="openImageReport('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
              </div>
              <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                *ngIf="message.isAuditTrailUser" (click)="openImageTrail('overAll',0)"
                (keydown.enter)="openImageTrail('overAll',0)">
                <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Audit Trail</span>
              </div>
              <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
                <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
                <span class="reload_text">Reload</span>
              </div>
            </div>
          </div>

          <div class="table-container">
            <table style="height: 60vh;">
              <thead style="z-index:9">
                <th style="min-width: 60px; text-align: center;">
                  <div style="display: flex;">
                    <div>
                      <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                  </div>
                </th>

                <th class="grid-header-container"
                  [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Report Image Name</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div (click)="sortColumn('Report Image Name',organizationReportImage)"
                        (keydown.enter)="sortColumn('Report Image Name',organizationReportImage)">
                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                  <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                      (input)="reportImageColumnSearch('reportImageName', $event,'string')" />
                  </div>
                </th>

                <th class="grid-header-container"
                  [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Report Image Extn</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div (click)="sortColumn('Report Image Extn',organizationReportImage)"
                        (keydown.enter)="sortColumn('Report Image Extn',organizationReportImage)">
                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                  <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                      (input)="reportImageColumnSearch('reportImageExtn', $event,'string')" />
                  </div>
                </th>

                <th class="grid-header-container"
                  [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Applicable Modules</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div (click)="sortColumn('Applicable Modules',organizationReportImage)"
                        (keydown.enter)="sortColumn('Applicable Modules',organizationReportImage)">
                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                  <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                      (input)="reportImageColumnSearch('applicableModules', $event,'string')" />
                  </div>
                </th>

                <th class="grid-header-container"
                  [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Module Ref Name</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div (click)="sortColumn('Module Ref Name',organizationReportImage)"
                        (keydown.enter)="sortColumn('Module Ref Name',organizationReportImage)">
                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                  <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                      (input)="reportImageColumnSearch('moduleRefName', $event,'string')" />
                  </div>
                </th>

                <th class="grid-header-container"
                  [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Is Report Image Square</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div (click)="sortColumn('Is Report Image Square',organizationReportImage)"
                        (keydown.enter)="sortColumn('Is Report Image Square',organizationReportImage)">
                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                  <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                      (input)="reportImageColumnSearch('isReportImageSquare', $event,'string')" />
                  </div>
                </th>

                <th class="grid-header-container"
                  [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Use as Default</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div (click)="sortColumn('Use as Default',organizationReportImage)"
                        (keydown.enter)="sortColumn('Use as Default',organizationReportImage)">
                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                  <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                      (input)="reportImageColumnSearch('useAsDefault', $event,'string')" />
                  </div>
                </th>

                <th class="grid-header-container"
                  [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Created On</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div (click)="sortColumn('Created On',organizationReportImage)"
                        (keydown.enter)="sortColumn('Created On',organizationReportImage)">
                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                  <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                      (input)="reportImageColumnSearch('createdOnStr', $event,'date')" />
                  </div>
                </th>

                <th class="grid-header-container"
                  [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Created By</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div (click)="sortColumn('Created By',organizationReportImage)"
                        (keydown.enter)="sortColumn('Created By',organizationReportImage)">
                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                  <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                      (input)="reportImageColumnSearch('createdByUser', $event,'string')" />
                  </div>
                </th>

                <th class="grid-header-container"
                  [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Updated On</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div (click)="sortColumn('Updated On',organizationReportImage)"
                        (keydown.enter)="sortColumn('Updated On',organizationReportImage)">
                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                  <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                      (input)="reportImageColumnSearch('updatedOnStr', $event,'date')" />
                  </div>
                </th>

                <th class="grid-header-container"
                  [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>Updated By</span>
                    <div class="d-flex gap-2 align-items-center">
                      <div (click)="sortColumn('Updated By',organizationReportImage)"
                        (keydown.enter)="sortColumn('Updated By',organizationReportImage)">
                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                      </div>
                    </div>
                  </div>
                  <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                      (input)="reportImageColumnSearch('updatedByUser', $event,'string')" />
                  </div>
                </th>
                <th id="menu" class="sticky-col first-col"></th>
              </thead>

              <tr *ngFor="let list of pagedItems1; let idx = index;" [class.highlightRow]="list.childCheckBox == true">
                <td style="min-width: 60px; text-align: center;">
                  <div style="display: flex;">
                    <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                      <i class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                    <div>
                      <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBox"
                        (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                    </div>
                  </div>
                </td>

                <td class="sticky-dynamic-row1"
                  [ngStyle]="{'min-width':'100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  {{list.reportImageName}}
                </td>

                <td class="sticky-dynamic-row1"
                  [ngStyle]="{'min-width':'100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  {{list.reportImageExtn}}
                </td>

                <td class="sticky-dynamic-row1"
                  [ngStyle]="{'min-width':'100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  {{list.applicableModules}}
                </td>

                <td class="sticky-dynamic-row1"
                  [ngStyle]="{'min-width':'100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  {{list.moduleRefName}}
                </td>

                <td class="sticky-dynamic-row1"
                  [ngStyle]="{'min-width':'100px','max-width': '200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                  <span>
                    <div class="gridCheckBoxes">
                      <img *ngIf="list.isReportImageSquare == 'Y'" src="../../../assets/img/accessSymbol.svg" width="20"
                        height="20" alt="Yes">
                      <img *ngIf="list.isReportImageSquare != 'Y'" src="../../../assets/img/noAcessSymbol.svg"
                        width="20" height="20" alt="No">
                    </div>
                  </span>
                </td>

                <td class="sticky-dynamic-row1"
                  [ngStyle]="{'min-width':'100px','max-width': '200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                  <span>
                    <div class="gridCheckBoxes">
                      <img *ngIf="list.useAsDefault == 'Y'" src="../../../assets/img/accessSymbol.svg" width="20"
                        height="20" alt="Yes">
                      <img *ngIf="list.useAsDefault != 'Y'" src="../../../assets/img/noAcessSymbol.svg" width="20"
                        height="20" alt="No">
                    </div>
                  </span>
                </td>

                <td class="sticky-dynamic-row1"
                  [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  {{list.createdOnStr | date:'dd-MMM-yyyy HH:mm:ss'}}
                </td>
                <td class="sticky-dynamic-row1"
                  [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  {{list.createdByUser}}
                </td>
                <td class="sticky-dynamic-row1"
                  [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  {{list.updatedOnStr | date:'dd-MMM-yyyy HH:mm:ss'}}
                </td>
                <td class="sticky-dynamic-row1"
                  [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                  {{list.updatedByUser}}
                </td>

                <td class="sticky-col first-col">
                  <div class="action-icons">
                    <i class="fa-solid fa-pencil" matTooltip="Edit" style="margin-left: 5px;"
                      (click)="openEditReportImagePopup(list)" (keydown.enter)="openEditReportImagePopup(list)"></i>
                    <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete" style="margin-left: 5px;"
                      (click)="openDeleteReportImagePopup(list)" (keydown.enter)="openDeleteReportImagePopup(list)"></i>
                    <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
                      src="../../assets/img/trail-individual.svg" (click)="openImageTrail('individual',list)"
                      (keydown.enter)="openImageTrail('individual',list)" />
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>

            <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setReportImagePage(pager.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic4" ngbDropdownToggle>
                  {{perPage}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
                  <button ngbDropdownItem (click)="reportImagePagination(10)">10</button>
                  <button ngbDropdownItem (click)="reportImagePagination(20)">20</button>
                  <button ngbDropdownItem (click)="reportImagePagination(50)">50</button>
                </div>
                per page
              </div>
            </nav>
            <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Report Color Codes">
      <ng-template mat-tab-label>
        <span>Report Color Codes</span>
      </ng-template>
      <br>
      <div class="menu-container">
        <div class="row menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="gridName">Report Color Codes</span>
          </div>
        </div>
      </div>

      <br>
      <div class="row">
        <div class="col-md-3">
          <div><label for="email">Header Color</label></div>
          <div class="row">
            <div class="col-md-10"><input class="input-filed-continers " type="text"
                [(ngModel)]="organizationImage.reportHeaderColorCode" [disabled]="true"></div>
            <div class="col-md-2">
              <input class="color-picker" [(colorPicker)]="organizationImage.reportHeaderColorCode"
                [style.background]="organizationImage.reportHeaderColorCode" />
            </div>
          </div>

        </div>
        <div class="col-md-3">
          <div><label for="email">Header Font Color</label></div>
          <div class="row">
            <div class="col-md-10"><input class="input-filed-continers " type="text"
                [(ngModel)]="organizationImage.reportHeaderFontColorCode" [disabled]="true"></div>
            <div class="col-md-2">
              <input class="color-picker" [(colorPicker)]="organizationImage.reportHeaderFontColorCode"
                [style.background]="organizationImage.reportHeaderFontColorCode" />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div><label for="email">Sub Header Color</label></div>
          <div class="row">
            <div class="col-md-10"><input class="input-filed-continers " type="text"
                [(ngModel)]="organizationImage.reportSubheaderColorCode" [disabled]="true"></div>
            <div class="col-md-2">
              <input class="color-picker" [(colorPicker)]="organizationImage.reportSubheaderColorCode"
                [style.background]="organizationImage.reportSubheaderColorCode" />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div><label for="email">Sub Header Font Color</label></div>
          <div class="row">
            <div class="col-md-10"><input class="input-filed-continers " type="text"
                [(ngModel)]="organizationImage.reportSubheaderFontColorCode" [disabled]="true">
            </div>
            <div class="col-md-2">
              <input class="color-picker" [(colorPicker)]="organizationImage.reportSubheaderFontColorCode"
                [style.background]="organizationImage.reportSubheaderFontColorCode" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div><label for="email">Label Color</label></div>
          <div class="row">
            <div class="col-md-10"><input class="input-filed-continers " type="text"
                [(ngModel)]="organizationImage.reportLabelColorCode" [disabled]="true"></div>
            <div class="col-md-2">
              <input class="color-picker" [(colorPicker)]="organizationImage.reportLabelColorCode"
                [style.background]="organizationImage.reportLabelColorCode" />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div><label for="email">Label Font Color</label></div>
          <div class="row">
            <div class="col-md-10"><input class="input-filed-continers " type="text"
                [(ngModel)]="organizationImage.reportLabelFontColorCode" [disabled]="true"></div>
            <div class="col-md-2">
              <input class="color-picker" [(colorPicker)]="organizationImage.reportLabelFontColorCode"
                [style.background]="organizationImage.reportLabelFontColorCode" />
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="IP Address">
      <br>
      <div class="menu-container">
        <div class="row menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="gridName">IP Address</span>
          </div>
        </div>
      </div> <br>

      <div class="position-relative grid-content">
        <div>
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center px-3">
              <div class="dropdown">
              </div>
            </div>
            <div class="d-flex gap-3">
              <div class="header-container" *ngIf="grid.length">
                <div class="">
                  <div class="search-container">
                    <span class="fa fa-search form-control-feedback"></span>
                    <input type="text" class="form-control search_input" style="font-size: 12px"
                      placeholder="Search here..." [(ngModel)]="searchValue" />
                  </div>
                </div>
              </div>
              <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                *ngIf="message.dataGridAdmin && grid.length" (click)="openReorder()" (keydown.enter)="openReorder()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
                  <path style="fill:'#FFFFFF'"
                    d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
                </svg>
                <span class="reload_text text-white">Settings</span>
              </div>
              <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openIPAddPopup()" (keydown.enter)="openIPAddPopup()">
                <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                <span class="reload_text text-white">Add New</span>
              </div>
              <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openIPReport('Excel')" (keydown.enter)="openIPReport('Excel')" *ngIf="grid.length">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
              </div>
              <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openIPReport('Pdf')" (keydown.enter)="openIPReport('Pdf')" *ngIf="grid.length">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
              </div>
              <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
                <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
                <span class="reload_text">Reload</span>
              </div>
            </div>
          </div>
        </div>
        <div class="align-center" *ngIf="!grid.length">
          No Data
        </div>
        <div class="table-container" *ngIf="grid.length">
          <table class="dynamic-table-container">
            <th style="min-width: 60px;background: white; text-align: center;"
              [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
              <div style="display: flex;">
                <div>
                  <i id="parent-menu-icon" class="fa-solid fa-ellipsis-vertical"></i>
                </div>
              </div>
            </th>
            <th id="grid-header-container1"
              *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
              [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width,'max-width': oneQmsUsersDataForTable1Data.width,'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
              class="sticky-dynamic-col1">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
                <div class="d-flex gap-2 align-items-center">
                  <div (click)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)"
                    (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)">
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th id="menu-icons" class="sticky-col first-col"></th>
            <tr>
              <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
              <td *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
                [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
                class="sticky-dynamic-col1" (mouseover)="cssFunction(0)" (focus)="focusEmpty()">
                <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                    (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>
              </td>
            </tr>
            <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
              <td style="min-width: 60px;background: white; text-align: center;"
                [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                <div style="display: flex;">
                  <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <div>
                    <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBox"
                      (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                  </div>
                </div>
              </td>
              <td id="grid-row-container1" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                class="sticky-dynamic-row1"
                [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                <span *ngIf="key.dataType=='CHECKBOX'">
                  <div class="gridCheckBoxes">
                    <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                      height="20">
                    <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" alt="No"
                      width="20" height="20">

                  </div>
                </span>
                <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
                  <div class="download-button-continer btn-align" mat-dialog-actions>
                    <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                      (click)="getClobData(list,key.columnsListarray)">
                      <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                      <span class="ms-1">View</span>
                    </button>
                  </div>
                </span>


                <span
                  *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa'">
                  {{ list[key.columnsListarray] }}
                </span>

                <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
              </td>
              <td class="sticky-col first-col">
                <div class="action-icons">
                  <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete" style="margin-left: 5px;"
                    (click)="openIPDeletePopup(list)" (keydown.enter)="openIPDeletePopup(list)"></i>
                </div>
              </td>
            </tr>
          </table>
          <div class="d-flex justify-content-center">
            <div class="width-cheat small paginationCell">
              <div class="d-flex align-items-center gap-3">
                <div class="pagination_text mt-3">
                  {{ showingRowsText }}
                  1-{{ perPage }} of {{ collectionSize | number }}
                </div>
                <div>
                  <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
                    [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                    [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true"
                    size="sm">
                  </ngb-pagination>
                </div>
                <div ngbDropdown class="mt-3">
                  <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                    ngbDropdownToggle>
                    {{ perPage }}
                    <i class="ms-1 fa-solid fa-chevron-down"></i>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                    <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                    <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                  </div>
                  per page
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab style=" background: transparent; cursor: default; pointer-events: none;"
      label=" &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                 &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ">
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #uploadImagesPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelImageFunction()" mat-button><i style="font-size: 23px;color: gold;"
      class="fa">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }} </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 10px 10px;">
    <div class="row" *ngIf="imageTy=='nonadditional'">
      <div class="col-md-12" id="upload-btn-wrapper">
        <button class="btn" (click)="openImageDialog()">Choose image...</button>
        <input id="uploadInputValue" #fileInputMain type="file" name="myfile" style="display: none;"
          (change)="chooseImage($event)" />
        <div class="upload-validation-container">
          <span id="logo-error-icon" class="fas fa-exclamation-circle"></span><span id="logo-error-msg">Please
            choose JPG/JPEG or PNG images only</span>
          <span id="logo-required-icon" class="fas fa-exclamation-circle"></span><span id="logo-required-msg">Please
            choose the image</span>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="imageTy=='additional'">
      <div class="col-md-12" id="upload-btn-wrapper1">
        <button class="btn" (click)="openImageDialog2()">Choose image...</button>
        <input id="uploadInputValue1" #fileInput2 type="file" name="myfile" style="display: none;"
          (change)="chooseImageAdd($event)" />
        <div class="upload-validation-container">
          <span id="logo-error-icon" class="fas fa-exclamation-circle"></span><span id="logo-error-msg">Please
            choose JPG/JPEG or PNG images only</span>
          <span id="logo-required-icon" class="fas fa-exclamation-circle"></span><span id="logo-required-msg">Please
            choose the image</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #angularEditorTextarea>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelAngularEditorData()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ this.textareaEditorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]="buttonsIncludedConfig" [spellcheck]="true"
        (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="okAngularEditorData(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAngularEditorData()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #infoPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="okInfo()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Update</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div class="row">
      <div class="col-md-12">
        <div><label for="email">Reason for Update</label><span class="mandatory-symbol">*</span></div>
        <textarea id="updateReason" type="text" name="updateReason" class="input-filed-textarea" rows="6" cols="50"
          [(ngModel)]="organization.updateReason" (focusout)="onFieldFocusout()"
          style="width: 100% !important;"></textarea>
        <span id="updateReason-required-msg">Please provide the reason for update</span>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" [disabled]="!organization.updateReason"
        (click)="updateOneQmsOrganization(organization, organizationImage)">
        Update
      </button>
      <button mat-stroked-button class="addButton" (click)="okInfo()">
        Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #trailPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeTrailPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="email" class="popupTitle"> Audit Trail </label>
    <label for="email" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="audit-block-container">
    <div class="audit-block" (click)="triggerAuditTrail(0)" (keydown.enter)="triggerAuditTrail(0)">
      Organization
    </div>
    <div class="audit-block" (click)="triggerAuditTrail(1)" (keydown.enter)="triggerAuditTrail(1)">
      License Privileges
    </div>
    <div class="audit-block" (click)="triggerAuditTrail(2)" (keydown.enter)="triggerAuditTrail(2)">
      Images
    </div>
    <div class="audit-block" (click)="triggerAuditTrail(3)" (keydown.enter)="triggerAuditTrail(3)">
      Report Color Codes
    </div>
  </div>
</ng-template>

<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeReportPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="email" class="popupTitle"> {{reportType == 'Excel' ? 'Excel Report' :'Pdf Report'}} </label>
    <label for="email" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="audit-block-container">
    <div class="audit-block" (click)="openReport(reportType,0)" (keydown.enter)="openReport(reportType,0)">
      Organization
    </div>
    <div class="audit-block" (click)="openReport(reportType,1)" (keydown.enter)="openReport(reportType,1)">
      License and Privileges
    </div>
    <div class="audit-block" (click)="openReport(reportType,2)" (keydown.enter)="openReport(reportType,2)">
      Images
    </div>
    <div class="audit-block" (click)="openReport(reportType,3)" (keydown.enter)="openReport(reportType,3)">
      Report Color Codes
    </div>
  </div>
</ng-template>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddOrEditImagePopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">{{reportImagePopupTitle}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <div class="col-md-2 field-styles">
          <div>
            <label for="email" id="module-validation">Modules</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput multiple placeholder="Select" #modules [(ngModel)]="selectedModule"
            (closed)="modulesSearchText=''" (click)="focusSearch('focus-modules-search')"
            (keydown.enter)="focusSearch('focus-modules-search')">
            <input type="search" id="focus-modules-search" class="dropdownsearchstyle" [(ngModel)]="modulesSearchText"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isAllModulesSelected" (change)="toggleAllSelection('modules')">
                Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of modulesDropdown | multiAssessmentSearchPipe :modulesSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onModulesSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3 field-styles" id="group-validation"
          *ngIf="selectedModule.length==1 && singleSelected=='QMS'">
          <div>
            <label for="email">Groups</label>
          </div>
          <mat-select matInput multiple placeholder="Select" #groups [(ngModel)]="selectedQmsGroup"
            (closed)="groupSearchText=''" (click)="focusSearch('focus-group-search')"
            (keydown.enter)(click)="focusSearch('focus-group-search')">
            <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isAllGroupSelected" (change)="toggleAllSelection('groups')">Select
                All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of qmsGroupDropdown | multiAssessmentSearchPipe :groupSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onGroupSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3 field-styles" id="folder-validation"
          *ngIf="selectedModule.length==1 && singleSelected=='DOCS'">
          <div>
            <label for="email">Folders</label>
          </div>
          <mat-select matInput multiple placeholder="Select" #documents [(ngModel)]="selectedDmsFolder"
            (closed)="documentsSearchText=''" (click)="focusSearch('focus-documents-search')"
            (keydown.enter)="focusSearch('focus-documents-search')">
            <input type="search" id="focus-documents-search" class="dropdownsearchstyle"
              [(ngModel)]="documentsSearchText" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isAllDocumentsSelected" (change)="toggleAllSelection('documents')">Select
                All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of dmsFolderDropdown | multiAssessmentSearchPipe :documentsSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onDocumentsSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3 field-styles">
          <div>
            <label for="email" id="report-image-name-validation">Report Image Name</label>
          </div>
          <input type="text" class="input-filed-continers" [(ngModel)]="organizationReportImage.reportImageName">
        </div>
        <div class="col-md-4 field-styles">
          <div>
            <label for="email"
              *ngIf="organizationReportImage?.reportImageName">{{organizationReportImage.reportImageName}}
            </label>
          </div>
          <div class="row imgBtnAlign">
            <div class="col-sm-4 imgBtnAlign">
              <img *ngIf="reportImageView" class="org-image" [src]="reportImageView" alt="report" />
              <img *ngIf="organizationReportImage?.reportImage && !addTime && !reportImageView" class="org-image"
                src="data:image/*;base64,{{organizationReportImage.reportImage}}" alt="report" />
              <div *ngIf="!organizationReportImage?.reportImage && !reportImageView">No Image</div>
            </div>

            <div class="col-sm-4">
              <div class="button-continer btn-align" mat-dialog-actions
                *ngIf="organizationReportImage?.reportImage == null">
                <button mat-stroked-button class="uploadButton" (click)="openReportImageUploadPopup('additional')">
                  <i class="fas fa-upload"></i> Upload
                </button>
              </div>
              <div class="button-continer btn-align" mat-dialog-actions
                *ngIf="organizationReportImage.reportImage != null">
                <button mat-stroked-button class="clearButton" (click)="clearReportImageAdd()">
                  <i class="fa fa-remove"></i> Clear
                </button>
              </div>
              <div id="report-success-icon1" class="far fa-check-circle">
                <span id="report-success-msg1">Image chosen</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br><br>
      <div class="row">
        <div class="col-sm-3">
          <div><label for="email">Is Report Image Square?</label></div>
          <mat-slide-toggle color="primary" name="reportEnabled"
            [(ngModel)]="organizationReportImage.isReportImageSquare">
            <ng-container *ngIf="organizationReportImage.isReportImageSquare; else noReportImageSquare">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noReportImageSquare>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
        <div class="col-sm-3">
          <div><label for="email">Use As Default?</label></div>
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="organizationReportImage.useAsDefault">
            <ng-container *ngIf="organizationReportImage.useAsDefault; else noUseAsDefault">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noUseAsDefault>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditReportImage()" (keydown.enter)="addAndEditReportImage()">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Save</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddOrEditImagePopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteReportImagePopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Reason for Delete</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea uppercase" style="width: 100%;" rows="4"
            cols="50" [(ngModel)]="organizationReportImage.deleteReason"></textarea>
          <span id="deleteTextarea-required-msg">Please provide the reason for delete</span>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="deleteReportImage()"
        (keydown.enter)="deleteReportImage()">
        <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
        <span class="reload_text text-white">Delete</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteReportImagePopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #addAndEditDynamicPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddOrEditIPPopup()" mat-button>
      <i style="font-size: 23px; color: white;" class="fa">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle">{{ ipPopupTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color: gold;">QMS</span></label>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div>
          <label for="ip" id="ip-validation">IP Address </label>
          <span class="mandatory-symbol">*</span>
        </div>
        <input id="fieldName" class="input-filed-continers" type="text" [(ngModel)]="ipAddress"
          (ngModelChange)="onNgModelChange(orgIpAddress, 'ip-validation')">
      </div>
      <div class="col-md-6">
        <div><label for="allowed-Till-validation">Allowed Till</label></div>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="allowedTill">
      </div>
      <div class="col-md-6">
        <div>
          <label for="justification" id="justification-validation">Justification</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <textarea id="justification" rows="4" class="input-filed-textarea" type="text" [(ngModel)]="justification"
          (ngModelChange)="onNgModelChange($event,'justification-validation')"></textarea>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addOrEditIP()"
          (keydown.enter)="addOrEditIP()" *ngIf="visibleAddButton">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addOrEditIP()"
          (keydown.enter)="addOrEditIP()" *ngIf="visibleEditButton">
          <i class="fas fa-user-edit" style="font-size: 18px; color: white;"></i>
          <span class="reload_text text-white">Update</span>
        </div>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelAddOrEditIPPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #deleteDynamicPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelIPDeletePopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Delete IP Address </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div><label for="deleteReason" id="delete-reason"> Reason for Delete</label><span
              class="mandatory-symbol">*</span>
          </div>
          <textarea rows="4" class="input-filed-textarea" type="text" [(ngModel)]="orgIpAddress.deleteReason"
            (ngModelChange)="onNgModelChange($event,'delete-reason')"></textarea>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteIP()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelIPDeletePopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<input id="org-file" #orgFile type="file" name="myfile" style="display: none;" (change)="chooseFile($event)" />
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>
<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>